import { render } from "./TheMyCollectionItemListView.vue?vue&type=template&id=7def353a&scoped=true&ts=true"
import script from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemListView.vue?vue&type=style&index=0&id=7def353a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7def353a"]])

export default __exports__